import { AxiosResponse } from 'axios'
import api from '~/services/api'
import { ISendPayload } from './../model/types'

export const sendMessage = async (payload: ISendPayload) => {
  const res: AxiosResponse<{ success: boolean }> = await api.post('/notification/send', {
    shop_code: payload.shopCode,
    message: payload.message,
    message_type: payload.messageType,
    user_id: payload.userId,
    order_id: payload.orderId,
    session_id: payload.sessionId,
    transaction_id: payload.transactionId
  })
  return res.data.success
}
